<template>
  <div v-show="visible" class="modal__getArhive">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title getArhive__title">Запрос на сбор архива успешно выполнен</h4>
        <button type="button" class="close popap__btn-close" @click="hide">
          <i><img src="/img/ic_close_chip.svg" alt=""></i>
        </button>
      </div>
      <div class="modal-body">
        <p class="modal__getArhive__text">
          Подготовка архива с данными референсов занимает некоторое время.<br>
          После формирования архива ссылка для скачивания придет на указанный email <strong>{{email}}</strong>.
        </p>
        <p class="modal__getArhive__text">
          Большие архивы в несколько гигабайт могут формироваться длительное время.<br>
          Если в течении 24 часов вы не получили письма, то проверьте папку СПАМ.<br>
          Мы отправляем письма с адреса <strong>support@api.systeme.ru</strong>
        </p>
        <button @click="hide" type="button" class="btn popap__content-btn success-modal-btn">ОК</button>
      </div>
    </div>
    <div class="modal-backdrop show" @click="hide"></div>
  </div>
</template>

<script>

export default {
  name: 'archive-success-modal',
  data () {
    return {
      email: null,
      visible: false
    }
  },
  mounted () {
    this.$root.$on('archive-success-modal::show', this.show)
  },
  methods: {
    show (email) {
      document.body.classList.add('modal-open')
      this.email = email
      this.visible = true
    },
    hide () {
      document.body.classList.remove('modal-open')
      this.visible = false
    }
  },
  beforeDestroy () {
    this.$root.$off('archive-success-modal::show', this.show)
  }
}
</script>